// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZaiDataStamp {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  font-size: 10px;
  color: var(--color_neutral_800);
}`, "",{"version":3,"sources":["webpack://./src/components/ZaiDataStamp/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;AACF","sourcesContent":[".ZaiDataStamp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 8px;\n  font-size: 10px;\n  color: var(--color_neutral_800);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
